import {
  FUNDING_SEGREGATION_NOT_APPLIED_PATTERN,
  INACTIVE_ZERO_LIQUIDATION_PATTERN,
} from '../insights/optimizerDecisionActionPatterns';

export type OptimizerDecisionPredicateInput = {
  stage: string;
  action: string;
};

/** Engine logs $0 inactive sleeves as liquidation; hide from advisor-facing notes. */
export const isInactiveZeroAccountDecision = (
  decision: OptimizerDecisionPredicateInput,
): boolean =>
  decision.stage === 'LIQUIDATION' &&
  INACTIVE_ZERO_LIQUIDATION_PATTERN.test(decision.action);

/** Single-pool fallback — not an advisor-facing multi-currency situation. */
export const isFundingSegregationNotApplied = (
  decision: OptimizerDecisionPredicateInput,
): boolean =>
  decision.stage === 'FUNDING_SEGREGATION' &&
  FUNDING_SEGREGATION_NOT_APPLIED_PATTERN.test(decision.action);
